import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { config } from '../configs/config';

import Backend from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    // .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        lng: 'en',
        fallbackLng: 'en',
        debug: false,
        keySeparator: false,

        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },

        backend: {
            loadPath: `${config.cdnUrl[0]}/assets/locales/zavehub/{{lng}}/{{ns}}.json`,
            // loadPath: 'https://zave-stg.s3-ap-southeast-1.amazonaws.com/assets/locales/zavehub/{{lng}}/{{ns}}.json',
            crossDomain: true,
            //fetch options: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch
            requestOptions: { // used for fetch, can also be a function (payload) => ({ method: 'GET' })
                method: 'GET',
                mode: 'cors',
                credentials: 'same-origin',
                cache: 'default'
            },
            // adds parameters to resource URL. 'example.com' -> 'example.com?v=1.3.5'
            queryStringParams: { v: '1.0.2' },
        }
    });


export default i18n;
